export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
export const KEYCLOAK_CLIENT_SECRET =
  process.env.REACT_APP_KEYCLOAK_CLIENT_SECRET;
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM;
export const KEYCLOAK_AUTH_SERVICE =
  process.env.REACT_APP_KEYCLOAK_AUTH_SERVICE;
export const BASE_URL = process.env.REACT_APP_SERVER_URL;
export const CLIENT_TIMEOUT_MS = process.env.REACT_APP_CLIENT_TIMEOUT_MS;
